"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseForm = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _utils = require("../../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultTrigger = 'change';

var BaseForm = /*#__PURE__*/function () {
  function BaseForm() {
    (0, _classCallCheck2.default)(this, BaseForm);
    this.attrs = {
      initData: {}
    };
    this.values = {};
    this.meta = {};
  }

  (0, _createClass2.default)(BaseForm, [{
    key: "hasOwnField",
    value: function hasOwnField(name) {
      return this.values.hasOwnProperty(name);
    }
  }, {
    key: "resetField",
    value: function resetField(name) {
      this.values[name] = undefined;
      this.meta[name] = {
        rules: [],
        initData: undefined,
        trigger: defaultTrigger,
        valuePropName: 'value',
        hasChange: false,
        errors: []
      };
    }
  }, {
    key: "addField",
    value: function addField(name) {
      if (this.hasOwnField(name)) {
        console.error('[Form]: Can not set the same name ' + name);
        return;
      }

      this.resetField(name);
    }
  }, {
    key: "removeField",
    value: function removeField(name) {
      delete this.values[name];
      delete this.meta[name];
    }
  }, {
    key: "setMeta",
    value: function setMeta(name, meta) {
      if (!this.meta.hasOwnProperty(name)) {
        console.error('[Form]: can not set value not in form, name: ' + name);
        return;
      }

      this.meta[name] = _objectSpread(_objectSpread({}, this.meta[name]), meta);
    }
  }, {
    key: "getMeta",
    value: function getMeta(name) {
      return this.meta[name];
    }
  }, {
    key: "getValue",
    value: function getValue(name) {
      var value = this.values[name];
      var meta = this.meta[name];

      if ((value === undefined || value === null) && !meta.hasChange) {
        if (meta.initData) {
          return meta.initData;
        }

        try {
          return (0, _utils.getDataByName)(this.attrs.initData, name);
        } catch (e) {
          return undefined;
        }
      }

      return value;
    }
  }, {
    key: "getValues",
    value: function getValues(names) {
      var _this = this;

      if (!names) {
        names = this.allFieldNames;
      }

      var out = {};
      names.forEach(function (name) {
        out[name] = _this.getValue(name);
      });
      return out;
    }
  }, {
    key: "setValues",
    value: function setValues(obj) {
      var _this2 = this;

      Object.keys(obj).forEach(function (name) {
        if (!_this2.values.hasOwnProperty(name)) {
          console.error('[Form]: can not set value not in form, name: ' + name);
          return;
        }

        _this2.values[name] = obj[name];
      });
    }
  }, {
    key: "resetFields",
    value: function resetFields(names) {
      var _this3 = this;

      if (!names) {
        names = this.allFieldNames;
      }

      names.forEach(function (name) {
        _this3.resetField(name);
      });
    }
  }, {
    key: "setInitValues",
    value: function setInitValues(values) {
      this.attrs.initData = values || {};
    }
  }, {
    key: "getError",
    value: function getError(name) {
      return this.getMeta(name) && this.getMeta(name).errors;
    }
  }, {
    key: "getErrors",
    value: function getErrors(names) {
      var _this4 = this;

      if (!names) {
        names = this.allFieldNames;
      }

      var out = {};
      names.forEach(function (name) {
        out[name] = _this4.getError(name);
      });
      return out;
    }
  }, {
    key: "allFieldNames",
    get: function get() {
      return Object.keys(this.values);
    }
  }]);
  return BaseForm;
}();

exports.BaseForm = BaseForm;